__webpack_require__.p = "/getup-exercise/";